import { Component } from "@angular/core";
import { NotifierService } from "src/app/_services/notifier.service";
import { APIService } from "src/app/api/api.service";
import { environment } from "src/environments/environment";
import { AzureCostOptimizationBaseComponent } from "../azure-costoptimization-base.component";

@Component({
  selector: "app-azure-disks-cost-optimization",
  templateUrl: "../azure-costoptimization-base.component.html",
  styleUrls: ["../azure-costoptimization-base.component.css"],
})
export class AzureDisksCostOptimizationComponent extends AzureCostOptimizationBaseComponent {
  pageHeading: string = "Disk Cost Control";
  recommendationSummary: string =
    "Recommendations are based on Premium SSD to Premium SSD v2 analysis for the selected Azure resource group.";
  protected scanAction: string = "disks";

  headers: any = [
    { id: "resource_name_status", name: "Disk Name", filter: true },
    { id: "current_sku", name: "Current SKU" },
    { id: "target_sku", name: "Target SKU" },
    { id: "disk_size_gb", name: "Disk Size (GB)" },
    { id: "current_monthly_cost_usd", name: "Current Cost (USD)" },
    {
      id: "projected_monthly_cost_after_migration_usd",
      name: "Projected Cost (USD)",
    },
    { id: "estimated_monthly_savings_usd", name: "Savings (USD)" },
    { id: "estimated_savings_percent", name: "Savings (%)" },
    { id: "Reason", name: "Reason", filter: true },
    { id: "recommendation", name: "Recommendation", filter: true },
  ];

  constructor(apiService: APIService, notifier: NotifierService) {
    super(apiService, notifier);
  }

  protected getCreateScanBasePath(): string {
    return `${environment.apiURL}/${this.urlPrefix}/azure/costoptimization/api/optimization/premium-ssd-v2-recommendations`;
  }

  protected getCreateScanParams(): any {
    return {
      user_id: this.userId,
      subscription_id: this.accountId,
      resource_group_name: this.resourceGroup,
      estimated_savings_percent: 15,
    };
  }
}
